import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Collapse, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ThemeLib } from '@payface-frontends-libs/theme';
const { typography } = ThemeLib.Generics;
const ListItemStyle = styled(ListItem)(({ theme }) => ({
    ...typography.body2,
    height: 48,
    textTransform: 'capitalize',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(2.5),
    color: theme.palette.text.secondary,
    '&.isActiveRoot': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium,
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        '&:before': {
            top: 0,
            right: 0,
            width: 3,
            bottom: 0,
            content: "''",
            position: 'absolute',
            backgroundColor: theme.palette.primary.main,
        },
    },
    '&.isActiveSub': {
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightMedium,
        '& .subIcon:before': {
            transform: 'scale(2)',
            backgroundColor: theme.palette.primary.main,
        },
    },
}));
const SubIconStyle = styled('span')(({ theme }) => ({
    width: 22,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:before': {
        width: 4,
        height: 4,
        content: "''",
        display: 'block',
        borderRadius: '50%',
        backgroundColor: theme.palette.text.disabled,
        transition: theme.transitions.create('transform'),
    },
}));
export function SidebarItem({ level, title, href, info, icon, open = false, children }) {
    const [show, setShow] = useState(open);
    const isSubItem = level > 0;
    const handleShow = () => {
        setShow((show) => !show);
    };
    if (children) {
        return (_jsxs(_Fragment, { children: [_jsxs(ListItemStyle, Object.assign({ button: true, disableGutters: true, onClick: handleShow, className: open ? 'isActiveRoot' : '' }, { children: [_jsx(ListItemIcon, { children: icon && icon }, void 0), _jsx(ListItemText, { disableTypography: true, primary: title }, void 0), info && info, _jsx(Box, { component: Icon, icon: show ? arrowIosDownwardFill : arrowIosForwardFill, sx: { width: 16, height: 16, ml: 1 } }, void 0)] }), void 0), _jsx(Collapse, Object.assign({ in: show }, { children: children }), void 0)] }, void 0));
    }
    return (_jsxs(ListItemStyle, Object.assign({ button: true, to: href, exact: open, disableGutters: true, component: RouterLink, activeClassName: isSubItem ? 'isActiveSub' : 'isActiveRoot', isActive: (match, location) => {
            if (!match) {
                return false;
            }
            const { url } = match;
            const { pathname } = location;
            const isMatch = url === pathname;
            if (!isSubItem) {
                return url.length && pathname.includes(url);
            }
            return isMatch;
        } }, { children: [_jsx(ListItemIcon, { children: isSubItem ? _jsx(SubIconStyle, { className: "subIcon" }, void 0) : icon }, void 0), _jsx(ListItemText, { disableTypography: true, primary: title }, void 0), info && info] }), void 0));
}
//# sourceMappingURL=SidebarItem.js.map